export const AMAZON_TRACE_ID_HEADER = 'x-amzn-trace-id';
export const AUTHORIZATION = 'authorization';
export const COUNTRY_OVERRIDE_HEADER = 'country-configuration-override';
export const CSRF_TOKEN_HEADER = 'X-CSRFToken';
export const FORWARDED_FOR_HEADER = 'x-forwarded-for';
export const FORWARDED_HOST_HEADER = 'x-forwarded-host';
export const FORWARDED_PROTOCOL_HEADER = 'x-forwarded-proto';
export const ROVER_FORWARDED_PROTOCOL_HEADER = 'x-rover-forwarded-proto';
export const HOST_HEADER = 'host';
export const INFOSEC_SCAN_HEADER = 'qualys-scan';
export const IP_OVERRIDE_HEADER = 'ip-address-override';
export const ORIGINAL_REQUEST_PATH_HEADER = 'x-rover-ssr-original-request-path';
export const REQUEST_ID_HEADER = 'x-request-id';
export const ROVER_SEARCH_EVENT_ID_HEADER = 'x-rover-search-event-id';
export const SSR_REDIRECT_HEADER = 'x-ssr-redirect-meta';
export const USER_AGENT_HEADER = 'user-agent';
export const MOBILE_EMBEDDED_HEADER = 'x-mobile-embedded';
export const CF_IPCITY_HEADER = 'Cf-Ipcity';
export const CF_IPCONTINENT_HEADER = 'Cf-Ipcontinent';
export const CF_IPCOUNTRY_HEADER = 'Cf-Ipcountry';
export const CF_IPLATITUDE_HEADER = 'Cf-Iplatitude';
export const CF_IPLONGITUDE_HEADER = 'Cf-Iplongitude';
export const CF_IPMETRO_CODE_HEADER = 'Cf-Metro-Code';
export const CF_IPPOSTAL_CODE_HEADER = 'Cf-Postal-Code';
export const CF_IPREGION_CODE_HEADER = 'Cf-Region-Code';
export const CF_IPREGION_HEADER = 'Cf-Region';
export const ROVER_PROPERTY = 'x-rover-property';
export const ROVER_GINGR_OVERRIDE_CBSA_HEADER = 'x-rover-override-gingr-cbsa';
